export default object =>
  Object.entries(object)
    .reduce((accumulator, [key, value]) => `${accumulator}${key}=${value}&`, '')
    .slice(0, -1)
    .toLowerCase()
